import { TMemberEditorState } from '../types/TMemberEditorState';
import { TMembershipLike } from '../types/TMembershipLike';
import { TTeamMemberOption } from '../types/TTeamMemberOption';
import { toTeamMemberOption } from './toTeamMemberOption';

type TInput = {
  teamMembers: readonly TMembershipLike[];
  availableMembers: readonly TMembershipLike[];
  draftMemberIds: ReadonlySet<string> | null;
};

export const deriveMemberEditorState = ({
  teamMembers,
  availableMembers,
  draftMemberIds,
}: TInput): TMemberEditorState => {
  const persistedMemberIds = new Set(teamMembers.map((membership) => membership.id));

  const roster = new Map<string, TTeamMemberOption>();
  for (const membership of [...teamMembers, ...availableMembers]) {
    if (!roster.has(membership.id)) {
      roster.set(membership.id, toTeamMemberOption(membership));
    }
  }

  const draft = draftMemberIds ?? persistedMemberIds;
  const rosterOptions = [...roster.values()];

  return {
    members: rosterOptions.filter((option) => draft.has(option.membershipId)),
    available: rosterOptions.filter((option) => !draft.has(option.membershipId)),
    draftMemberIds: draft,
    persistedMemberIds,
  };
};
